import React from 'react'
import styled from 'react-emotion'
import Menu from './Menu'
import Trigger from './Trigger'

const Dropup = ({ isMenuVisible, ticketId, ...rest }) => {
  return (
    <React.Fragment>
      <Trigger upward direction="left" active={isMenuVisible} {...rest} />
      {isMenuVisible && <Menu ticketId={ticketId} />}
    </React.Fragment>
  )
}

export default styled(Dropup)`
  .cannedReplyModalRoot {
    width: calc(100vw - 64px);
    height: calc(100vh - 96px);
    min-width: 280px;
    max-width: 640px;
  }
`
